module.exports = __webpack_public_path__ + "img/mesa_el_v.3c755c7e.png";